<app-modal-header title="Perfect your prompt" subtitle="Compare the rewrite before you use it" />

<app-modal-body>
  @switch (status()) {
    @case ('idle') {
      <div class="prompt-optimizer__block">
        <p class="prompt-optimizer__label">Your question</p>
        <p class="prompt-optimizer__text">{{ data.question }}</p>
      </div>
    }
    @case ('loading') {
      <div class="prompt-optimizer__block" aria-live="polite">
        <p class="prompt-optimizer__label">Optimizing…</p>
        <app-skeleton height="20px" radius="4px" />
        <app-skeleton height="20px" width="80%" radius="4px" />
      </div>
    }
    @case ('error') {
      <p class="form-error" role="alert">Something went wrong optimizing this prompt. Please try again.</p>
    }
    @case ('ready') {
      <div class="prompt-optimizer__block">
        <p class="prompt-optimizer__label">Original</p>
        <p class="prompt-optimizer__text">{{ data.question }}</p>
      </div>
      <div class="prompt-optimizer__block">
        <p class="prompt-optimizer__label">Optimized</p>
        <p class="prompt-optimizer__text prompt-optimizer__text--optimized">{{ optimized() }}</p>
      </div>
    }
  }
</app-modal-body>

<app-modal-footer>
  <button type="button" class="btn--secondary" (click)="cancel()">Cancel</button>
  @switch (status()) {
    @case ('idle') {
      <button type="button" class="btn--primary" data-modal-autofocus (click)="optimize()">Optimize</button>
    }
    @case ('loading') {
      <button type="button" class="btn--primary" disabled>Optimizing…</button>
    }
    @case ('error') {
      <button type="button" class="btn--primary" (click)="optimize()">Try again</button>
    }
    @case ('ready') {
      <button type="button" class="btn--primary" (click)="useOptimized()">Use this version</button>
    }
  }
</app-modal-footer>
